import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import {ForecastQueryRenderer} from '../../../ForecastQueryRenderer';
import {useClientContactProjectOptions, ProjectsViewerEdges, ProjectOption} from './hooks/useClientContactProjectOptions';

export const clientContactModalProjectsLoaderQuery = graphql`
	query ClientContactModalProjectsLoaderQuery {
		viewer {
			component(name: "client_contact_modal_projects")
			actualPersonId
			projects(first: 100000) @connection(key: "Viewer_projects", filters: []) {
				edges {
					node {
						id
						name
						customProjectId
						projectColor
						client {
							id
						}
					}
				}
			}
		}
	}
`;

export type ClientContactModalProjectsLoaderProps = {
	clientId: string;
	children: (modalProps: {projectOptions: ProjectOption[]; isProjectsLoading: boolean}) => React.ReactNode;
};

type ProjectOptionsInnerProps = {
	edges: ProjectsViewerEdges | undefined;
	clientId: string;
	isLoading: boolean;
	children: ClientContactModalProjectsLoaderProps['children'];
};

// Keep a stable component instance for the children regardless of query state
// so any form state inside the rendered modal survives the loaded → resolved
// transition (otherwise React unmounts the fragment branch and remounts the
// children, wiping their state).
const ProjectOptionsInner = ({edges, clientId, isLoading, children}: ProjectOptionsInnerProps) => {
	const projectOptions = useClientContactProjectOptions(edges, clientId);
	return <>{children({projectOptions: isLoading ? [] : projectOptions, isProjectsLoading: isLoading})}</>;
};

const ClientContactModalProjectsLoader = ({clientId, children}: ClientContactModalProjectsLoaderProps) => (
	<ForecastQueryRenderer
		key="client-contact-projects"
		query={clientContactModalProjectsLoaderQuery}
		modal={true}
		alwaysRender={true}
		variables={{}}
		render={(relayProps: {viewer?: {projects?: {edges?: ProjectsViewerEdges}}} | null) => {
			const isLoading = !relayProps || !relayProps.viewer;
			return (
				<ProjectOptionsInner
					edges={relayProps?.viewer?.projects?.edges}
					clientId={clientId}
					isLoading={isLoading}
					children={children}
				/>
			);
		}}
	/>
);

export default ClientContactModalProjectsLoader;
